"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.schemaConta = exports.yupConta = void 0;
const yup = __importStar(require("yup"));
const enums_1 = require("../enums");
exports.yupConta = yup.object({
    idEmpresa: yup.number().positive().required().integer().label('Empresa'),
    apelido: yup.string().max(40, 'Máximo de 40 caracteres.').default('').label('Apelido'),
    titular: yup.string().required().max(40, 'Máximo de 40 caracteres.').default('').label('Titular'),
    cidade: yup.string().max(30, 'Máximo de 30 caracteres.').default('').label('Cidade'),
    agencia: yup.string().max(6, 'Máximo de 6 caracteres.').default('').label('Agência'),
    conta: yup.string().max(12, 'Máximo de 12 caracteres.').default('').label('Conta'),
    convenio: yup.string().max(16, 'Máximo de 16 caracteres.').default('').label('Convênio'),
    diasAntecedentesCDesc: yup.number().min(0).default(0).label('Dias Antecedentes p/ Concessão do Desconto'),
    diasUteisAntecedentesCDesc: yup.boolean().default(false).label('Dias úteis'),
    usaJuno: yup.boolean().default(false).label('Cobrança Fácil'),
    junoBoletoBancario: yup.boolean().default(false).label('Boleto Bancário'),
    junoBoletoPix: yup.boolean().default(false).label('Boleto PIX'),
    junoCartaoCredito: yup.boolean().default(false).label('Cartão de Crédito'),
    junoSubsBoletoReg: yup.boolean().default(false).label('Substituir boletos registrados'),
    junoToken: yup.string().max(256, 'Máximo de 256 caracteres.').default('').label('Token'),
    junoClientId: yup.string().max(256, 'Máximo de 256 caracteres.').default('').label('Client ID'),
    junoClientSecret: yup.string().max(256, 'Máximo de 256 caracteres.').default('').label('Client Secret'),
    junoPixKey: yup.string().max(50, 'Máximo de 50 caracteres.').default('').label('Chave Pix'),
    usaIugu: yup.boolean().default(false).label('Utilizar Iugu'),
    iuguBoletoBancario: yup.boolean().default(false).label('Boleto Bancário'),
    iuguBoletoPix: yup.boolean().default(false).label('Boleto PIX'),
    iuguCartaoCredito: yup.boolean().default(false).label('Cartão de Crédito'),
    iuguSubsBoletoReg: yup.boolean().default(false).label('Substituir boletos registrados'),
    iuguToken: yup.string().max(256, 'Máximo de 256 caracteres.').default('').label('Token'),
    usaBBrasil: yup.boolean().default(false).label('Utilizar Banco do Brasil'),
    bBrasilBoletoBancario: yup.boolean().default(false).label('Boleto Bancário BB'),
    bBrasilBoletoPix: yup.boolean().default(false).label('Boleto PIX'),
    bBrasilSubsBoletoReg: yup.boolean().default(false).label('Substituir boletos registrados'),
    bBrasilToken: yup.string().max(256, 'Máximo de 256 caracteres.').default('').label('Token'),
    bBrasilClientId: yup.string().max(256, 'Máximo de 256 caracteres.').default('').label('Client ID'),
    bBrasilClientSecret: yup.string().max(256, 'Máximo de 256 caracteres.').default('').label('Client Secret'),
    debCartao: yup.boolean().default(false).label('Calcular Tarifa no Recebimento Manual'),
    debDiasLib: yup.number().integer().min(0).default(0).label('Dias para Compensação'),
    debPercTar: yup.number().min(0).default(0).label('Tarifa'),
    juros: yup.number().min(0).default(0).label('Juros'),
    multa: yup.number().min(0).default(0).label('Multa'),
    prazoDevol: yup.number().min(0).default(0).label('Dias Após Vencto'),
    imprimeValorIntegral: yup.boolean().default(false).label('Imprimir o Valor Integral'),
    codBanco: yup
        .mixed()
        .oneOf(Object.values(enums_1.EBancos))
        .required()
        .default(enums_1.EBancos['999 Outro Banco'])
        .label('Banco'),
    inativa: yup.boolean().default(false).label('Conta inativa'),
    cnpj: yup.string().max(18, 'Máximo de 18 caracteres.').default('').label('CNPJ'),
    lancaTarifa: yup.number().min(0).default(0).label('Tarifa'),
    diasLiberacaoCobranca: yup.number().min(0).default(0).label('Dias p/ Liberação da Cobrança'),
    diasUteisLiberacaoCobranca: yup.boolean().default(false).label('Dias úteis p/ Liberação da Cobrança'),
    geraResiduo: yup.boolean().default(false).label('Gera Resíduo na Baixa Automática'),
    debitoAutomatico: yup.boolean().default(false).label('Débito Automático'),
    creditoEducativo: yup.boolean().default(false).label('Crédito Educativo'),
    cobrancaBancaria: yup.boolean().default(false).label('Cobrança Bancária'),
    terceirizada: yup.boolean().default(false).label('Terceirizada'),
    aplicacaoFinanceira: yup.boolean().default(false).label('Aplicação Financeira'),
    contaCapital: yup.boolean().default(false).label('Conta Capital'),
    baixaSomenteConta: yup.boolean().default(false).label('Baixa somente parcelas impressas nesta conta'),
    localPagamento: yup.string().max(150, 'Máximo de 150 caracteres.').default('').label('Local Pgto'),
    envResp: yup.boolean().default(false).label('Endereço de Cobrança'),
    envNome: yup
        .mixed()
        .oneOf(Object.values(enums_1.ENomeCobranca))
        .default(enums_1.ENomeCobranca['Responsável'])
        .label('Nome na Cobrança'),
    fintech: yup.mixed().oneOf(Object.values(enums_1.EFintech)).default(enums_1.EFintech['Juno']).label('Fintech'),
    boleCode: yup.boolean().default(false).label('Gerar QrCode através arquivo de remessa banco Itaú'),
    chavePixBoleCode: yup
        .string()
        .max(100, 'Máximo de 100 caracteres.')
        .default('')
        .label('Chave Pix para arquivo de remessa banco Itaú'),
});
exports.schemaConta = exports.yupConta.shape({});
